import Vue from 'vue';
import Router from 'vue-router';
import { fetchSearchSettings } from '@/api/docs';
import store from '@/store';
import getFilters from '@/data/search-filters';
import getMetadata from '@/data/search-metadata';
import { bootstrap } from 'vue-gtag';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: { name: 'docs-search' },
    meta: {
      application: 'docs',
      searchText: 'Search for sites...',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/Login.vue'),
    meta:{
      layout: 'plain'
    }
  },
  {
    path: '/docs',
    name: 'docs-search',
    meta: {
      title: 'Search Documents',
      searchPage: true,
      embed: true,
      metadataFields: [],
      filters: [
        {
          attribute: 'folders.fileId',
          urlParam: 'folder',
          title: 'Folder Id',
          block: false,
          hidden: true,
        },
      ],
    },
    beforeEnter: (to, from, next) => {
      if(!store.getters.isAuthorized) {
        return next();
      }
      if(!to.query.apikey) {
        store.dispatch('setError',404);
        return next();
      }
      fetchSearchSettings(to.query.apikey).then((response) => {
        if(response.status != 200){
          store.dispatch('setSearchSettings', {});
          store.dispatch('setError', response.status);
        }
        else store.dispatch('setSearchSettings', response.data);
        next();
      }).catch((error) => {
        store.dispatch('setError', error.response.status);
        next();
      });
    },
    component: () => import('./views/Docs.vue'),
  },
];


const router = new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

let clearError = true;

router.beforeEach(async (to, from, next) => {
  document.title = process.env.VUE_APP_TITLE + (to.meta.title ? ` - ${to.meta.title}` : '');
  clearError = false;
  if (store.state.errorCode) {
    clearError = true;
  }

  await store.dispatch('loadSessionData');
  if(store.state.gAPIError) {
    return next();
  }
  if(!store.getters.isLoggedIn && to.name != 'Login') return next({ name: 'Login' , query: { redirect: to.fullPath }, replace: true });
  if(store.getters.isLoggedIn && to.name == 'Login') return window.location.replace(to.query.redirect || '/');
  next();
});


router.beforeResolve(async (to, from, next) => {
  if (clearError) {
    store.dispatch('setError', false);
  }
  const layout = to.meta.layout || 'default';

  if (process.env.VUE_APP_ENV === 'prod') {
    bootstrap().then(() => {});
  }

  store.dispatch('toggleLoader', false);

  next();
});


export default router;
